var MenuVoceMenuComponent = /** @class */ (function () {
    function MenuVoceMenuComponent() {
        this.classes = '';
    }
    Object.defineProperty(MenuVoceMenuComponent.prototype, "isSecondoLivelloDesktop", {
        set: function (isSecondoLivelloDesktop) {
            if (isSecondoLivelloDesktop) {
                this.classes = 'dropdown-item pointer dropdown-secondo-livello';
                if (this.voce && this.voce.figli && this.voce.figli.length > 0) {
                    this.classes += ' dropdown-toggle';
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return MenuVoceMenuComponent;
}());
export { MenuVoceMenuComponent };
